var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1131 3.17266C13.0894 2.19635 14.6723 2.19635 15.6486 3.17266L16.8271 4.35117C17.8034 5.32748 17.8034 6.9104 16.8271 7.88671L8.16669 16.5471C8.05035 16.6635 7.90219 16.7428 7.74086 16.775L3.32145 17.6589C2.73834 17.7755 2.22424 17.2614 2.34086 16.6783L3.22475 12.2589C3.25701 12.0976 3.33631 11.9494 3.45264 11.8331L12.1131 3.17266ZM14.4701 4.35117L15.6486 5.52969C15.974 5.85512 15.974 6.38276 15.6486 6.7082L14.4701 7.88671L12.1131 5.52969L13.2916 4.35117C13.617 4.02574 14.1447 4.02574 14.4701 4.35117ZM10.9346 6.7082L4.80957 12.8332L4.22031 15.7795L7.16659 15.1902L13.2916 9.06522L10.9346 6.7082Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2641d34bbbdf8d35cf921b662518c1fe.svg";
export { ForwardRef as ReactComponent };